import { mainSiteUrl } from '@/mocks/categories';

export default function CtaSection() {
  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20warm%20inviting%20shopping%20scene%20with%20a%20beautifully%20arranged%20collection%20of%20fashion%20items%20on%20a%20sunlit%20minimal%20surface%2C%20soft%20cream%20and%20warm%20terracotta%20tones%2C%20natural%20afternoon%20daylight%2C%20modern%20lifestyle%20editorial%20photography%2C%20aspirational%20calm%20atmosphere%2C%20high%20detail%20product%20styling&width=1920&height=600&seq=cta-main-v3&orientation=landscape"
          alt="Ready to start shopping with Sugargoo Spreadsheet - Explore thousands of curated products"
          title="Start Shopping With Sugargoo Spreadsheet"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/35 to-black/50"></div>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-background-50 mb-4">
          Ready to Discover Amazing Products?
        </h2>
        <p className="text-sm md:text-base text-background-50/80 mb-8 max-w-lg mx-auto leading-relaxed">
          Join thousands of smart shoppers using the most complete Sugargoo Spreadsheet to find products faster and shop with confidence.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-9 py-3.5 text-base font-semibold bg-primary-500 text-background-50 rounded-lg hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-shopping-bag-line mr-2"></i>
            Sugargoo Spreadsheet
          </a>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-9 py-3.5 text-base font-semibold bg-background-50/15 text-background-50 border border-background-50/30 rounded-lg hover:bg-background-50/25 transition-all duration-300 whitespace-nowrap cursor-pointer backdrop-blur-sm"
          >
            <i className="ri-flashlight-line mr-2"></i>
            Buy It Now
          </a>
        </div>
      </div>
    </section>
  );
}